import { render, staticRenderFns } from "./SubscribersList.vue?vue&type=template&id=2f5218b9&scoped=true&"
import script from "./SubscribersList.vue?vue&type=script&lang=js&"
export * from "./SubscribersList.vue?vue&type=script&lang=js&"
import style0 from "./SubscribersList.vue?vue&type=style&index=0&id=2f5218b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5218b9",
  null
  
)

export default component.exports